import apiFetch from '../apiFetch'

export default function (token, dossierId, detailsId) {
  return apiFetch({ endPoint: `dossier/Campaign/${dossierId}/CampaignDetail/${detailsId}`, method: 'GET', body: null, token: token })
}
